import { render, staticRenderFns } from "./ui-components-overview.vue?vue&type=template&id=dd3c633c"
import script from "./ui-components-overview.vue?vue&type=script&lang=js"
export * from "./ui-components-overview.vue?vue&type=script&lang=js"
import style0 from "./ui-components-overview.vue?vue&type=style&index=0&id=dd3c633c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__clawFile = "playground/components/ui-components-overview"
export default component.exports